<template>
  <div class="d-inline-flex ga-2">
    <v-btn
      size="small"
      variant="outlined"
      color="#1877F2"
      @click="shareOnFacebook"
    >
      <v-icon start size="16">mdi-facebook</v-icon>
      Facebook
    </v-btn>

    <v-btn
      size="small"
      variant="outlined"
      color="#1DA1F2"
      @click="shareOnTwitter"
    >
      <v-icon start size="16">mdi-twitter</v-icon>
      Twitter
    </v-btn>

    <v-btn
      size="small"
      variant="outlined"
      color="#0A66C2"
      @click="shareOnLinkedIn"
    >
      <v-icon start size="16">mdi-linkedin</v-icon>
      LinkedIn
    </v-btn>

    <v-btn
      size="small"
      variant="outlined"
      @click="copyLink"
    >
      <v-icon start size="16">{{ copied ? 'mdi-check' : 'mdi-link-variant' }}</v-icon>
      {{ copied ? $t('blog.linkCopied') : $t('blog.copyLink') }}
    </v-btn>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'

const props = defineProps({
  slug: { type: String, required: true },
  title: { type: String, default: '' }
})

const copied = ref(false)

const ogUrl = `https://api.goerlev-station.dk/api/blog/og/${props.slug}`
const directUrl = `https://community.goerlev-station.dk/blog/${props.slug}`

const shareOnFacebook = () => {
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(ogUrl)}`,
    '_blank',
    'width=600,height=400'
  )
}

const shareOnTwitter = () => {
  window.open(
    `https://twitter.com/intent/tweet?url=${encodeURIComponent(ogUrl)}&text=${encodeURIComponent(props.title)}`,
    '_blank',
    'width=600,height=400'
  )
}

const shareOnLinkedIn = () => {
  window.open(
    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(ogUrl)}`,
    '_blank',
    'width=600,height=400'
  )
}

const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(directUrl)
    copied.value = true
    setTimeout(() => { copied.value = false }, 2000)
  } catch (e) {
    // Fallback
    const ta = document.createElement('textarea')
    ta.value = directUrl
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
    copied.value = true
    setTimeout(() => { copied.value = false }, 2000)
  }
}
</script>